import { motion } from "framer-motion";
import { STATS } from "@/data/company";

export default function Stats() {
  return (
    <section
      className="py-20 lg:py-28 bg-[#0F172A] text-white relative overflow-hidden"
      data-testid="stats-section"
    >
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)",
          backgroundSize: "60px 60px",
        }}
        aria-hidden
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-12">
          <div className="flex items-center gap-3 mb-4">
            <span className="w-10 h-[2px] bg-[#F59E0B]" />
            <span className="text-xs sm:text-sm font-bold uppercase tracking-[0.25em] text-white/60">
              The scale of our operations
            </span>
          </div>
          <h2 className="font-display font-black text-white text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
            Numbers that <span className="text-[#F59E0B]">roll</span>.
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 border-t border-l border-white/15">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`stat-${i}`}
              className="p-6 lg:p-10 border-r border-b border-white/15"
            >
              <div className="font-display font-black text-[#F59E0B] text-5xl lg:text-7xl tracking-tighter leading-none">
                {s.value}
              </div>
              <div className="mt-4 text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-white/70">
                {s.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
